import React from "react";
import Navbar from "./components/Navbar";
// import AboutNavbar from "./components/AboutNavbar";
import {
    BrowserRouter as Router,
    Routes,
    Route,
    useLocation,
    Navigate
} from "react-router-dom";
import Home from "./pages";
import About from "./pages/about";
import FAQ from "./pages/FAQ";
import Resources from "./pages/resources";
import SignUp from "./pages/signup";
import Support from "./pages/support";
import Login from "./pages/login"
import BottomNavbar from "./components/BottomNavbar";
import ForgotPassword from "./pages/forgotPassword";
import LoggedIn from "./pages/loggedInHome"
import ContactUs from "./pages/contactUs";
import EditAccountProfile from "./pages/editAccountProfile";
import PrivacyPolicy from "./pages/privacyPolicy";
import TermsOfService from "./pages/termsOfService";
import CompanyInfo from "./pages/CompanyInfo";
import FormSubmission from "./pages/FormSubmissionPage";
import AccessCode from "./pages/RDAFormWizard/AccessCode";
import SubmissionForm from "./pages/RDAFormWizard/SubmissionForm";
import TempPage from "./pages/RDAFormWizard/TempPage";
import SuccessPage from "./pages/RDAFormWizard/SuccessPage";
import ProtectedRoute from "./pages/ProtectedRoute";
import RDAAdminPage from "./pages/RDAFormWizard/RDAAdminPage";
import EventsDashboard from "./pages/admin/EventsDashboard";
import DancerDetail from "./pages/admin/DancerDetail";

const AppContent = () => {
  const location = useLocation();
  const isAboutPage = location.pathname === "/about"
  const isAdminPage = location.pathname.startsWith("/admin");

  return (
    <>
        <Navbar currentLocation={location.pathname}/>


            <Routes>
                {/* <Route exact path="/" element={<Home />} />
                <Route path="/login" element ={<Login />} />
                <Route path="/about" element={<About />} />
                <Route path="/resources" element={<Resources />} />
                <Route path="/support" element={<Support />} />
                <Route path="/FAQ" element={<FAQ />} />
                <Route path="/signup" element={<SignUp />} />
                <Route path="/forgotPassword" element={<ForgotPassword />} />
                <Route path="/home" element={<LoggedIn />} />
                <Route path="/contactUs" element={<ContactUs />} />
                <Route path="/editProfile" element={<EditAccountProfile/>}/>
                <Route path="/privacyPolicy" element={<PrivacyPolicy/>}/>
                <Route path="/terms" element={<TermsOfService/>}/>
                <Route path="/tempForm" element={<CompanyInfo/>}/> */}
                
                <Route path="/login" element ={<Login />} />
                <Route path="/admin/login" element ={<Login />} />
                <Route path="/" element ={<Navigate to="/accessCode" replace="true"/>}/>
                {/* <Route path="/formSubmission" element={<FormSubmission/>}/> */}
                <Route path="/form" element={<SubmissionForm/>}/>
                <Route path="/accessCode" element={<AccessCode/>}/>
                <Route path="/businessHome" element={<ProtectedRoute><RDAAdminPage/></ProtectedRoute>}/>

                {/* <Route path="/newEntry" element={<ProtectedRoute><TempPage/></ProtectedRoute>}/> */}
                <Route path="/successPage" element={<SuccessPage/>}/>
                {/* <Route path="*" element={<Navigate to="/accessCode" replace />} /> */}
                <Route path="/admin/events" element={<ProtectedRoute><EventsDashboard/></ProtectedRoute>}/>
                <Route path="/admin/events/:eventId/dancer/:dancerId" element={<ProtectedRoute><DancerDetail/></ProtectedRoute>}/>
                <Route path="*" element={<Navigate to="/accessCode" replace />} />
            </Routes>

        <BottomNavbar currentLocation={location.pathname}/>
    </>
  );
};

function App() {
  return (
<Router>
           <AppContent />
</Router>
    );
}

export default App;
